import { VideoContentStatusE } from '../../models/enums';
import { VersionT } from './../../models/models';
import { countExtraFrames } from './countExtraFrames';
import { hasVideoCorrectRes } from './hasVideoCorrectRes';
import { hasVideoExtraFrames } from './hasVideoExtraFrames';
import { isMoreThen12FPS } from './isMoreThen12FPS';

const getVersionsErrors = (versions: VersionT[]) => {
    const errors = versions
        .map(({ ActualFrameCount, ActualLength, RequiredLength, Name, VideoHeight, VideoWidth, StatusName }) => (
            {
                name: Name,
                // extraFrames: hasVideoExtraFrames(ActualFrameCount, ActualLength),
                resolutionError: !hasVideoCorrectRes(VideoWidth, VideoHeight),
                encodingError: StatusName === VideoContentStatusE.ENCODING_ERROR,
                incorrectLength: isMoreThen12FPS(countExtraFrames(ActualFrameCount, RequiredLength)),
            }
        ))
        .filter(({resolutionError, encodingError, incorrectLength }) => resolutionError || encodingError || incorrectLength);

    return errors;
};

export default getVersionsErrors;